import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['alert', 'pensionAmountDefault'];

  handleAmountChange(event) {
    const pensionDefault =
      this.pensionAmountDefaultTarget.getAttribute('data-value');
    const value = event.target.value;

    if (parseFloat(pensionDefault) < parseFloat(value)) {
      this.alertTarget.style.display = 'block';
    } else {
      this.alertTarget.style.display = 'none';
    }
  }
}
